import React, {useContext} from 'react';
import "./FeedProfilesSuggest.scss";
import { Link } from "react-router-dom";
import {useQueryClient,useQuery} from "@tanstack/react-query";
import {
    fetchHomeProfilesSuggest,
    HOME_PROFILES_SUGGEST_KEY
} from "../../../../api/public-voissa/home-feed";
import {
    USER_CURRENT_KEY,
} from "../../../../api/public-voissa/users";
import createLink from "../../../../libs/createLink";
import classNames from 'classnames';
import {isNoFollowProfil, genererViews} from "../../../../libs/helper";
import { ModalContext } from '../../../components2/ModalManager';
import Avatar from '../../../components/Avatar';
import InfiniteScrollLoading from '../../../components2/InfiniteScrollLoading/InfiniteScrollLoading';
import useProfileFollow from "../../../../hooks/useProfileFollow";
import CertifiedBadge from '../../../components2/CertifiedBadge';

const FeedProfilesSuggestCard = ({user, userIsConnected})=>{
    const { openModal } = useContext(ModalContext);

    const {isFollow, followState, handleFollow } = useProfileFollow({userId : user?._id, isRequest : false, follow : user.follow});

    const alreadyFollowed = userIsConnected && user.isFollowed;
    const onFollowProfile = () => {
        if (!alreadyFollowed) {
            !userIsConnected ? openModal('EncourageSignup') : handleFollow(user._id);
        }
    };
    const relLinkProfil = isNoFollowProfil(user) ? { rel: "nofollow" } : {};

    return (
        <div className="feed-profiles-suggest-card">
            <div className="feed-profiles-suggest-card-avatar">
                <Link to={createLink("userProfile", user)} {...relLinkProfil}>
                    <Avatar avatar={user.profile?.avatar}
                            gender={user.profile?.gender || "guest"}
                            height={40}
                            width={40}
                            online={user.online}
                            alt=""/>
                </Link>
            </div>
            <div className="feed-profiles-suggest-card-info">
                <div className='feed-profiles-suggest-card-info-firstline'>
                    <Link to={createLink("userProfile", user)} {...relLinkProfil}>
                        {user.username}  {!!user.isCertified && <CertifiedBadge />}
                    </Link>
                </div>
                <div className='feed-profiles-suggest-card-info-secondline'>
                    {genererViews(user.followersCount)} suiveurs • {genererViews(user.mediasCount)} publications
                </div>
            </div>

            <div className={classNames('feed-profiles-suggest-card-follow-btn', {'already-followed': isFollow})} onClick={onFollowProfile}>
                {['Suivre', 'Ne plus suivre', 'Suivre en retour'][followState]}
            </div>

        </div>
    )
}

const FeedProfilesSuggest = ()=>{
    const queryClient = useQueryClient();
    const userConnected = queryClient.getQueryData([USER_CURRENT_KEY]);
    const {isSuccess, data : dataUsersSuggested, isFetched} = useQuery(
        [HOME_PROFILES_SUGGEST_KEY],
        ()=> fetchHomeProfilesSuggest(),
        {
            staleTime : (1000 * 60),
            placeholderData : {
                data : []
            },
            select : (data) =>{
                return {
                    users : data.data
                }
            }
        }
    );

    return (
        <>
            {!isFetched && (
                <InfiniteScrollLoading/>
            )}
           {(isFetched && isSuccess) && dataUsersSuggested.users.map(user=><FeedProfilesSuggestCard userIsConnected={!!userConnected} key={user._id} user={user} />)}
        </>
    )
}

export default React.memo(FeedProfilesSuggest);